if (!customElements.get('product-recommendation')) {
  customElements.define('product-recommendation', class ProductRecommendation extends HTMLElement {
    static observedAttributes = ['data-filter-color', 'data-collection'];

    constructor() {
      console.log('product-recommendation-element constructor')
      super();
      this.data = '';
      this.url = ''
    }
    async connectedCallback() {
      console.log('product-recommendation-element connected');
      // console.log(this.dataset);

      if (this.dataset.collection === "") return;

      const url = new URL(this.dataset.collection);
      url.searchParams.set('sections', 'render-recommendation');
      url.searchParams.set('filter.p.m.attribute.colour_for_filtering', this.dataset.filterColor);
      this.url = url;

      await this.fetchData(this.url);
      await this.render();
  
    }

    async attributeChangedCallback(name, oldValue, newValue) {
      console.log('attribute changed', name, oldValue, newValue);
      if (oldValue === null) {
        console.log('no old value returning');
        return;
      }
      if (name === 'data-collection') {
        this.url = new URL(this.dataset.collection);
        this.url.searchParams.set('sections', 'render-recommendation');
        this.url.searchParams.set('filter.p.m.attribute.colour_for_filtering', this.dataset.filterColor);
      }
      if (name === 'data-filter-color') {
        this.url.searchParams.set('filter.p.m.attribute.colour_for_filtering', newValue);
      }
      await this.fetchData(this.url);
      this.render()
    }
    render() {
      this.innerHTML = this.data;
      EasySelect.init('[data-easy-select]:not(:empty)', {
        align: "top" 
      });
      
      // init nonMagsafe
      Array.from(this.querySelectorAll('select[name="id"]')).forEach(el => {
        this.toggleNonMagSafeForm(el);
      });

      // bind actions
      Array.from(this.querySelectorAll('select[name="id"]')).forEach(el => {
        el.addEventListener('change', (e) => {
          const image = el.closest('.product-recommendation').querySelector('img');
          console.log('image', image);
          image.removeAttribute('srcset');
          // image.removeAttribute('src');
          image.src = e.target.querySelector('option[value="'.concat(e.target.value, '"]')).dataset.imgUrl;

          const variantAvailable = Boolean(e.target.selectedOptions[0].dataset.available);
          console.log(variantAvailable, this.querySelector('.product-form form'), this.querySelector('[type="submit"][form="'.concat(this.querySelector('.product-form form').getAttribute('id'),'"]')));
          const addToCartBtn = this.querySelector('[type="submit"][form="'.concat(this.querySelector('.product-form form').getAttribute('id'),'"]'));
          if (variantAvailable) {
            addToCartBtn.querySelector('span').innerText = addToCartBtn.dataset.translationAddToCart;
            addToCartBtn.disabled = false;
          }
          else {
            addToCartBtn.querySelector('span').innerText = addToCartBtn.dataset.translationSoldOut;
            addToCartBtn.disabled = true;
          }
          this.toggleNonMagSafeForm(e.target);
        })
      })

      Array.from(this.querySelectorAll('[data-filter-group-param]')).forEach(el => {
        el.addEventListener('change', e => {
          this.url.searchParams.set(e.target.dataset.filterGroupParam, decodeURIComponent(e.target.value));
          this.dataset.collection = decodeURIComponent(this.url.toString());
        })
      });
    }
    async fetchData(url) {
      console.log(`fetching recommendations from ${url}`);
      const response = await fetch(url);
      const json = await response.json();
      const parser = new DOMParser();
      const html = parser.parseFromString(json['render-recommendation'], 'text/html');
      // return html.getElementById('shopify-section-render-recommendation').innerHTML;
      this.data = html.getElementById('shopify-section-render-recommendation').innerHTML;
    }

    toggleNonMagSafeForm(el) {
      console.log('trying to fetch non-magsafe');
      //fetch magsafe info
      const nonMagSafeForm = el.closest('.product-recommendation').querySelector('[data-variants]');
      // console.log(nonMagSafeForm);
      if (nonMagSafeForm) {
        const data = JSON.parse(atob(nonMagSafeForm.dataset.variants));
        // console.log(data);
        // console.log(data.map(item => item.color), el.selectedOptions[0].label);
        const nonMagSafeItem = data.find(item => item.color === el.selectedOptions[0].label);
        // console.log('nonMagSafeItem', nonMagSafeItem);
        if (nonMagSafeItem && nonMagSafeItem.available) {
          nonMagSafeForm.elements.id.value = nonMagSafeItem.variant;
          // console.log(nonMagSafeForm.elements["id"]);
          nonMagSafeForm.classList.remove('hidden');
          nonMagSafeForm.closest('div').classList.add('grid', 'grid-cols-2');
        } else {
          nonMagSafeForm.classList.add('hidden');
          nonMagSafeForm.closest('div').classList.remove('grid', 'grid-cols-2');
        }
      }
    }
  })
}